import {
  Body,
  Box,
  buttonLinkG4P,
  LocalizedString,
  useIsTouchScreen,
} from "@dbn/omnichannel-design-system-g4p";
import { RuntimeLocaleKey, useFormatMessage } from "../../intl";
import { useState } from "react";
import { FilePDFDialog } from "../Dialogs/FilePDFDialog/FilePDFDialog";
import { constant, pipe } from "fp-ts/function";
import { taskEither } from "fp-ts";
import { useCommand } from "../../useAPI";
import * as documentAPI from "../../Common/documentAPI";
import { UploadDocumentFlowType } from "../../globalDomain";
import { foldVariantReduced } from "../Dialogs/DocumentUploadDialog/utils";
import { useAppContext } from "../../useAppContext";

type Props = {
  productType?: UploadDocumentFlowType;
  label?: LocalizedString;
  disabledLink?: boolean;
};

export function PersonalDataProcessingDisclaimer(props: Props) {
  const formatMessage = useFormatMessage();
  const isBranchExperienceTouchScreen = useIsTouchScreen();
  const {
    apiParameters: { channel },
  } = useAppContext();

  const is3P = channel === "3P_InPerson";
  const [dataModalOpen, setDataModalOpen] = useState(false);

  const personalDataProcessingTemplates = useCommand(documentAPI.templates);
  const personalDataProcessingContent = useCommand(documentAPI.content);

  const translationKeyPrefix = props.productType
    ? foldVariantReduced(
        props.productType,
        () => (is3P ? "StandardLoan.3p." : ""),
        constant(""),
        constant("")
      )
    : "";

  const disclaimerLabel = isBranchExperienceTouchScreen
    ? formatMessage(
        "PersonalDataProcessingDisclaimer.byContinuingDisclaimer.externalScreeen"
      )
    : formatMessage(
        (translationKeyPrefix +
          "PersonalDataProcessingDisclaimer.byContinuingDisclaimer") as RuntimeLocaleKey
      );

  return (
    <Box>
      <Body size="small" weight="regular">
        {[
          props.label || disclaimerLabel,
          buttonLinkG4P(
            () => setDataModalOpen(true),
            formatMessage(
              (translationKeyPrefix +
                "PersonalDataProcessingDisclaimer.personalDataProcessing") as RuntimeLocaleKey
            ),
            formatMessage("Identification.personalDataProcessingLink.alt"),
            props.disabledLink
          ),
        ]}
      </Body>
      {dataModalOpen && (
        <FilePDFDialog
          onDismiss={() => setDataModalOpen(false)}
          title={formatMessage(
            "PersonalDataProcessingDisclaimer.personalDataProcessingTitle"
          )}
          file={pipe(
            personalDataProcessingTemplates({
              docsets: ["personalDataProcessing"],
            }),
            taskEither.chain(items =>
              personalDataProcessingContent({ docId: items[0].docId })
            )
          )}
        />
      )}
    </Box>
  );
}
